import React, { useEffect, useState } from "react";
import { getEmployee } from "../../services/employee/employee";
import {
  ContactPeople,
  SaveContactPerson,
  SaveLoanCompanyContactPerson,
} from "../../services/Loan/contactPerson";
import { SaveLoanCompanyHistory } from "../../services/Loan/companyHistory";
import Modal from "react-bootstrap/Modal";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { getLoanHistory } from "../../services/Loan/loanhistory";
import { use } from "react";

function LoanRequest({
  handleInputChange,
  values,
  SaveLoan,
  loanId,
  loading,
  setActiveTab,
  setSelectedLoanCompanies,
  selectedLoanCompanies,
  selectedCompanies,
  LoanByLoanId,
  contactPerson,
  allCompanies,
  setAllCompanies,
  setValues,
}) {
  const navigate = useNavigate();
  const [sourcingType, setSourcingType] = useState(values.sourcingType||"Office");
  const [employees, setEmployees] = useState("");
  const [contactPeople, setContactPeople] = useState([]);
  const [companyItem, setCompanyItem] = useState({});
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [loanStatus, setLoanStatus] = useState("Pending Leed");

  // loan status
  const [remark, setRemark] = useState("");
  const [statusName, setStatusName] = useState("");
  const [loanCompanyStatus, setLoanCompanyStatus] = useState("Pending Leed");
  const [currentDate, setCurrentDate] = useState("");

  // Added for multiple company selection - Initialize as empty array
  const [selectedCompanyContactPersons, setSelectedCompanyContactPersons] =
    useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [companyContactPersons, setCompanyContactPersons] = useState([]);
  const [selectedContactPersons, setSelectedContactPersons] = useState([]);
  
  // Add companiesId state to track selected company IDs
  const [companiesId, setCompaniesId] = useState([]);

  const getEmployees = async () => {
    const data = await getEmployee();
    if (data?.data?.success) {
      setEmployees(data.data.data);
      console.log(data.data.data, 44444444);
    } else {
      setEmployees([]);
    }
  };

  const saveLoanCompanyHistory = async (ID) => {
    const obj = {
      loanId: loanId,
      remark: remark,
      statusName: statusName,
      status: loanCompanyStatus,
      currentDate: currentDate,
    };
    obj.companyId = companyItem._id;

    const data = await SaveLoanCompanyHistory(obj);
    if (data.data.success) {
      setLoanStatus(loanCompanyStatus);
      if (loanCompanyStatus == "Final Leed") {
        SaveLoan("fourthStep", data.data.data._id, loanCompanyStatus);
      } else {
        SaveLoan("fourthStep", "", loanCompanyStatus);
      }
      setShow(false);
      toast.success(data.data.message);
    }
  };

  const ViewHistoryFn = (item) => {
    let obj = {
      companyId: item._id,
      loanId: loanId,
    };
    navigate("/history", { state: { obj } });
  };

  const getData = async (id) => {
    const obj = {
      companyId: id,
      loanId: loanId,
    };
    let data = await getLoanHistory(obj);
    if (data.data.success) {
      console.log("data", data.data.data);
      setLoanCompanyStatus(data.data.data[0].status);
      setStatusName(data.data.data[0].statusName);
      setRemark(data.data.data[0].remark);
      setCurrentDate(data.data.data[0].currentDate);
    } else {
      setLoanCompanyStatus();
      setStatusName();
      setRemark();
      setCurrentDate();
    }
  };

  const handleShow = (item) => {
    setCompanyItem(item);
    getData(item._id);
    console.log("item", item);
    setShow(true);
  };

  // When company is selected, get its contact persons
  const handleCompanyChange = (e) => {
    const companyId = e.target.value;
    setSelectedCompanyId(companyId);

    if (companyId) {
      const company = allCompanies.find((c) => c._id === companyId);
      if (company && company.company_contact_persons) {
        setCompanyContactPersons(company.company_contact_persons);
      } else {
        setCompanyContactPersons([]);
      }
    } else {
      setCompanyContactPersons([]);
    }
  };

  // Handle contact person selection
  const handleContactPersonChange = (e) => {
    const contactPersonId = e.target.value;
    if (contactPersonId) {
      const contactPerson = companyContactPersons.find(
        (cp) => cp._id === contactPersonId
      );
      if (contactPerson) {
        setSelectedContactPersons([...selectedContactPersons, contactPerson]);
      }
    }
  };

  // Add selected company and contact person to the list
  const addCompanyContactPerson = () => {
    if (selectedCompanyId) {
      const selectedCompany = allCompanies.find(
        (c) => c._id === selectedCompanyId
      );
      if (selectedCompany) {
        const newEntry = {
          company: selectedCompany,
          contactPersons:
            selectedContactPersons.length > 0 ? selectedContactPersons[0] : [],
        };

        const updatedContactPersons = [...selectedCompanyContactPersons, newEntry];
        setSelectedCompanyContactPersons(updatedContactPersons);
        
        // Immediately sync after update
        updateValuesAndSync(updatedContactPersons);

        setSelectedCompanyId("");
        setCompanyContactPersons([]);
        setSelectedContactPersons([]);
      }
    }
  };

  // Remove company and its contact persons from the list
  const removeCompanyContactPerson = (index) => {
    const updatedList = [...selectedCompanyContactPersons];
    const removedItem = updatedList[index];
    updatedList.splice(index, 1);
    setSelectedCompanyContactPersons(updatedList);

    // Immediately sync after update
    updateValuesAndSync(updatedList);
  };

  // Function to synchronize companiesId with selectedCompanyContactPersons
  const syncCompaniesId = (contactPersonsArray = selectedCompanyContactPersons) => {
    const currentCompaniesId = contactPersonsArray.map(item => 
      item?.company?._id || item?.companyId
    ).filter(id => id); // Filter out any undefined/null values
    
    setCompaniesId(currentCompaniesId);
    return currentCompaniesId;
  };

  // Effect to initialize selectedCompanyContactPersons from values
  useEffect(() => {
    if (
      Array.isArray(values?.companyNameAndContactPerson) &&
      values.companyNameAndContactPerson.length > 0
    ) {
      setSelectedCompanyContactPersons(values.companyNameAndContactPerson);
    }
  }, [values?.companyNameAndContactPerson]);

  // Helper function to update values and sync data
  const updateValuesAndSync = (contactPersonsArray) => {
    console.log("Selected Company Contact Persons:", contactPersonsArray);

    if (contactPersonsArray.length > 0) {
      const formattedData = contactPersonsArray.map((item) => {
        console.log("Processing item:", item);

        return {
          companyName: item?.company?.company_name || item?.companyName || "",
          contactPerson:
            item?.contactPersons?.name || item?.contactPerson || "",
          contactPersonMobile:
            item?.contactPersons?.mobile_no || item?.contactPersonMobile || "",
          companyId: item?.company?._id || item?.companyId || "",
        };
      });

      setValues((prevValues) => ({
        ...prevValues,
        companyNameAndContactPerson: formattedData,
      }));
    } else {
      // Clear the values if no companies selected
      setValues((prevValues) => ({
        ...prevValues,
        companyNameAndContactPerson: [],
      }));
    }
    
    // Sync companiesId array
    const currentCompaniesId = contactPersonsArray.map(item => 
      item?.company?._id || item?.companyId
    ).filter(id => id);
    
    setCompaniesId(currentCompaniesId);
    
    // Sync selectedLoanCompanies
    if (selectedLoanCompanies && allCompanies) {
      const syncedLoanCompanies = selectedLoanCompanies.filter(company => 
        currentCompaniesId.includes(company._id)
      );
      
      contactPersonsArray.forEach(item => {
        const companyId = item?.company?._id || item?.companyId;
        if (companyId && !syncedLoanCompanies.find(c => c._id === companyId)) {
          const company = allCompanies.find(c => c._id === companyId);
          if (company) {
            syncedLoanCompanies.push(company);
          }
        }
      });
      
      if (JSON.stringify(selectedLoanCompanies) !== JSON.stringify(syncedLoanCompanies)) {
        setSelectedLoanCompanies(syncedLoanCompanies);
      }
    }
  };

  // Effect to update values when selectedCompanyContactPersons length changes
  useEffect(() => {
    updateValuesAndSync(selectedCompanyContactPersons);
  }, [selectedCompanyContactPersons.length]); // Only depend on length, not the array itself

  // Initialize employees on mount
  useEffect(() => {
    getEmployees();
  }, []);

  // Debug log to show current companiesId
  useEffect(() => {
    console.log("Companies ID Array:", companiesId);
  }, [companiesId]);

  return (
    <>
      <fieldset>
        <legend>
          <span>Loan Details</span>
        </legend>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
            {
              <div>
                <label> Sourcing Type</label>
                <select
                  className="form-control"
                  onChange={(e) =>{ 
                    handleInputChange(e);
                    setSourcingType(e.target.value)
                  }}
                  name="sourcingType"
                  value={values.sourcingType||sourcingType}
                >
                  <option value="Office">Office</option>
                  <option value="Field">Field</option>
                  <option value="Dealer">Dealer</option>
                  <option value="RTO Agent">RTO Agent</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            }
            </div >
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label>Sourcing</label>
              <select
                className="form-control "
                onChange={(e) => handleInputChange(e)}
                name="sourcing"
                value={values.sourcing}
              >
                <option value="">--select--</option>
                {employees &&
                  employees?.filter(
                    (item) => item?.employee_type == sourcingType
                  )?.length > 0 &&
                  employees
                    ?.filter((item) => item?.employee_type == sourcingType)
                    ?.map((item, index) => (
                      <option key={index} value={item._id}>
                        {item.name}
                      </option>
                    ))}
              </select>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="">Loan Type</label>
              <select
                className="form-control"
                onChange={(e) => handleInputChange(e)}
                name="loan_type"
                value={values.loan_type}
              >
                <option value={"B.T.CASE"}>B.T.CASE</option>
                <option value={"REFINANCE"}>REFINANCE</option>
                <option value={"SALE PURCHASE"}>SALE PURCHASE</option>
                <option value={"EXISTING"}>EXISTING</option>
              </select>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="">Loan Request </label>
              <input
                className="form-control"
                placeholder="Enter Loan Request Amount"
                type="number"
                onChange={(e) => handleInputChange(e)}
                name="loan_request"
                value={values.loan_request}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="">Finance Company SC Name </label>
              <input
                className="form-control"
                placeholder="Enter Finance Company SC Name"
                type="text"
                onChange={(e) => handleInputChange(e)}
                name="financeCompanySCName"
                value={values.financeCompanySCName}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="">file Handling Officer </label>
              <input
                className="form-control"
                placeholder="Enter File Handling Officer "
                type="text"
                onChange={(e) => handleInputChange(e)}
                name="fileHandlingOfficer"
                value={values.fileHandlingOfficer}
              />
            </div>
          </div>

          {/* Company and Contact Person Selection Section */}
          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header">
                <h5>Select Companies and Contact Persons</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-5">
                    <div className="form-group">
                      <label htmlFor="">Company Name</label>
                      <select
                        className="form-control"
                        onChange={handleCompanyChange}
                        value={selectedCompanyId}
                      >
                        <option value="">--Select Company--</option>
                        {allCompanies.length > 0 &&
                          allCompanies.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.company_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div className="form-group">
                      <label htmlFor="">Contact Person</label>
                      <select
                        className="form-control"
                        onChange={handleContactPersonChange}
                        disabled={!selectedCompanyId}
                      >
                        <option value="">--Select Contact Person--</option>
                        {companyContactPersons.length > 0 &&
                          companyContactPersons.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.name || "Unknown"} (
                              {item.mobile_no || "No phone"})
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-2 d-flex align-items-end">
                    <button
                      className="btn btn-primary mt-2"
                      onClick={addCompanyContactPerson}
                      disabled={!selectedCompanyId}
                    >
                      <i className="fa fa-plus"></i> Add
                    </button>
                  </div>
                </div>

                {/* Display selected companies and contact persons */}
                {selectedCompanyContactPersons.length > 0 && (
                  <div className="mt-3">
                    <h6>Selected Companies and Contact Persons:</h6>
                    <ul className="list-group">
                      {selectedCompanyContactPersons.map((item, index) => (
                        <li
                          className="list-group-item d-flex justify-content-between align-items-center"
                          key={index}
                        >
                          <div>
                            <strong>
                              {item?.companyName || item?.company?.company_name}
                            </strong>
                            {(item.contactPersons || item.contactPerson) && (
                              <p>
                                {item.contactPersons
                                  ? item.contactPersons.name
                                  : item.contactPerson}{" "}
                                -{" "}
                                {item.contactPersons
                                  ? item.contactPersons.mobile_no
                                  : item.contactPersonMobile}
                              </p>
                            )}
                          </div>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeCompanyContactPerson(index)}
                          >
                            <i className="fa fa-minus"></i>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="form-buttons-w text-right">
            <span className=" text-right">
              <button
                className="btn btn-primary text-white"
                onClick={() => setActiveTab("secondStep")}
              >
                Back
              </button>
            </span>
            &nbsp;&nbsp;{" "}
            <span className=" text-right">
              <button
                className="btn btn-primary text-white"
                onClick={() => SaveLoan("fourthStep")}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  <span>Save</span>
                )}
              </button>
            </span>
            &nbsp;&nbsp;
          </div>
        </div>
      </fieldset>
      <div className="row">
        <fieldset>
          <legend>
            <span>Finance Company List</span>
          </legend>
          <div className="table-responsive">
            <table className="table table-lightborder">
              <thead>
                <tr>
                  <th>Company Type</th>
                  <th>Company Name</th>
                  <th>Company Coordinator Name</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {selectedCompanies?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.company_type}</td>
                    <td>{item.company_name}</td>
                    <td>
                      <div>
                        <p className="m-1">{item.company_coordinator_name}</p>
                        <p>{item.company_coordinator_mobile_no}</p>
                      </div>
                    </td>
                    <td className="text-center">
                      {item.status || "Pending Leed"}
                    </td>
                    <td className="text-center">
                      <button
                        className="text-success border-0 bg-white ps-2"
                        onClick={() => handleShow(item)}
                      >
                        Change Status
                      </button>
                      <button
                        className="text-primary border-0 bg-white ps-2"
                        onClick={() => ViewHistoryFn(item)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Loan Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>Select Status</label>
          <select
            name="loanCompanyStatus"
            className="form-control"
            value={loanCompanyStatus}
            onChange={(e) => setLoanCompanyStatus(e.target.value)}
          >
            <option value="Pending Leed">Pending Leed</option>
            <option value="Running Leed">Running Leed</option>
            <option value="Reject Leed">Reject Leed</option>
            <option value="Agree Leed">Agree Leed</option>
            <option value="Final Leed">Final Leed</option>
          </select>
          <br />
          <label>Reason</label>
          <input
            type="text"
            name="statusName"
            value={statusName}
            onChange={(e) => setStatusName(e.target.value)}
            className="form-control"
          />
          <br />
          <label>Status Description</label>
          <textarea
            type="text"
            rows={3}
            className="form-control"
            name="remark"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
          <br />
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            name="currentDate"
            value={currentDate}
            onChange={(e) => setCurrentDate(e.target.value)}
          />
          <br />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShow(false)}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() => saveLoanCompanyHistory(loanCompanyStatus)}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

// Helper function to get the appropriate badge class based on loan status
function getLoanStatusBadgeClass(status) {
  switch (status) {
    case "Pending Leed":
      return "badge-warning";
    case "Running Leed":
      return "badge-info";
    case "Reject Leed":
      return "badge-danger";
    case "Agree Leed":
      return "badge-success";
    case "Final Leed":
      return "badge-primary";
    default:
      return "badge-secondary";
  }
}

export default LoanRequest;